var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophyFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0h20a1 1 0 011 1v5a4 4 0 01-4 4h-.08A7 7 0 0113 15.92V19h-2v-3.08A7 7 0 015.08 10H5a4 4 0 01-4-4V1a1 1 0 011-1zm1 2v4a2 2 0 002 2V2H3zm17.414 5.414A2 2 0 0021 6V2h-2v6a2 2 0 001.414-.586z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20h4c5 0 5 4 5 4H5s0-4 5-4z"
  })));
}
export default SvgTrophyFill;